import React from "react";
import { useParams } from "react-router-dom";
import { Box, Grid, Paper, Typography } from "@material-ui/core";
import { APIError } from "../../components/APIError";
import { ExtendedContainer } from "../../components/ExtendedContainer";
import { useAccountContacts } from "../../api/hooks/useAccountContacts";
import { Contact } from "./components/Contact";
import { Skeleton } from "@material-ui/lab";

export const AccountContacts: React.FC = () => {
  const { accountNumber } = useParams();
  const { status, data: contacts, error } = useAccountContacts(accountNumber!);
  const numContacts = contacts?.length;

  return (
    <ExtendedContainer px={0} py={0} maxWidth="none">
      <Box mb={1.5}>
        <Typography variant="overline" data-testid="AccountContacts__Heading">
          Contacts
          {typeof numContacts !== "undefined" ? ` (${numContacts})` : null}
        </Typography>
      </Box>
      {error ? (
        <Box display="flex" justifyContent="flex-start">
          <APIError
            title="We could not load the contacts for this account."
            messages={[(error as Error).message]}
          />
        </Box>
      ) : status === "loading" ? (
        <Box component={Paper} data-testid="Contact__Loader" display="flex">
          <Grid container alignItems="center">
            <Grid item>
              <Box m={2} py={1.5}>
                <Skeleton
                  variant="circle"
                  width={24}
                  height={24}
                  animation="wave"
                />
              </Box>
            </Grid>
            <Grid item>
              <Skeleton
                variant="text"
                width={173}
                height={27}
                animation="wave"
              />
              <Skeleton
                variant="text"
                width={70}
                height={20}
                animation="wave"
              />
            </Grid>
          </Grid>
        </Box>
      ) : contacts ? (
        <>
          {contacts.map((contact) => (
            <Contact contact={contact} key={contact.id} />
          ))}
        </>
      ) : null}
    </ExtendedContainer>
  );
};
